export var FormSymbol = Symbol('form');
export var FieldSymbol = Symbol('field');
export var SchemaMarkupSymbol = Symbol('schemaMarkup');
export var SchemaSymbol = Symbol('schema');
export var SchemaExpressionScopeSymbol = Symbol('schemaExpression');
export var SchemaOptionsSymbol = Symbol('schemaOptions');
//# sourceMappingURL=context.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@formily/vue/esm/shared/context.js
// module id = null
// module chunks = 